var _g, _path, _path2, _circle, _g2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDriversinfoMarker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 70 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 65,
    height: 65,
    rx: 32.5,
    fill: "#1F2A49",
    fillOpacity: 0.5
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6097 30.3772C49.597 30.3503 49.5874 30.322 49.581 30.293C47.8834 22.5784 40.9394 17 33.0004 17C23.6268 17 16 24.6268 16 34.0004C16 38.2951 17.6108 42.4007 20.5327 45.5585C20.6715 45.707 20.8496 45.8132 21.0463 45.8646L39.8855 50.7925C40.4104 50.9306 40.9544 51.0007 41.5005 51.0007C44.3948 51.0007 46.8769 49.1009 47.6419 46.3426L47.9845 44.851C48.4211 42.95 50.0007 41.2634 50.0007 39.313V31.8753C50.0007 31.3313 49.852 30.8255 49.6097 30.3772ZM45.6444 45.5648C45.1322 47.8386 42.6587 49.3219 40.421 48.7375L32.3524 46.6274C25.5285 44.8428 18.125 41.0538 18.125 34.0004C18.125 25.7977 24.7998 19.125 33.0004 19.125C39.1949 19.125 44.6777 23.0153 46.8484 28.642C46.8581 28.6671 46.84 28.6877 46.8131 28.6877H30.8753C28.5314 28.6877 26.6252 30.5939 26.6252 32.9378C26.6252 34.3042 27.2882 35.5941 28.3975 36.391L33.8525 40.3075C35.8522 41.7419 38.2088 42.5005 40.6675 42.5005H43.2004C44.8099 42.5005 46.0024 43.9957 45.6444 45.5648ZM47.8757 39.313C47.8757 39.8995 47.3975 40.3755 46.8131 40.3755H40.6675C38.6551 40.3755 36.7277 39.755 35.0935 38.582L29.6385 34.6655C29.0818 34.266 28.7503 33.62 28.7503 32.9378C28.7503 31.7669 29.7023 30.8128 30.8753 30.8128H46.8131C47.3975 30.8128 47.8757 31.2888 47.8757 31.8753V39.313Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9801 31.876H31.9589C31.3702 31.876 30.907 32.352 30.907 32.9385C30.907 33.525 31.3936 34.001 31.9801 34.001C32.5666 34.001 33.0427 33.525 33.0427 32.9385C33.0427 32.352 32.5666 31.876 31.9801 31.876Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 58,
    cy: 12,
    r: 12,
    fill: "#74DE4F"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58 8.12467C58.2944 8.12942 58.5867 8.17765 58.8678 8.2679C58.7377 8.50375 58.6685 8.77004 58.6667 9.04134C58.6667 9.252 58.7069 9.4606 58.7851 9.65523C58.8633 9.84986 58.9778 10.0267 59.1223 10.1757C59.2667 10.3246 59.4382 10.4428 59.627 10.5234C59.8157 10.604 60.018 10.6455 60.2222 10.6455C60.4853 10.6436 60.7435 10.5722 60.9722 10.4381C61.1527 11.0834 61.1316 11.771 60.9121 12.4033C60.6926 13.0356 60.2857 13.5807 59.7491 13.9613C59.2125 14.3419 58.5734 14.5387 57.9223 14.5239C57.2712 14.5091 56.6411 14.2835 56.1213 13.8789C55.6014 13.4742 55.2182 12.9112 55.0259 12.2695C54.8336 11.6279 54.842 10.9401 55.0498 10.3036C55.2576 9.66704 55.6544 9.1141 56.1839 8.72304C56.7134 8.33199 57.3487 8.12265 58 8.12467ZM50.0967 10.9148C51.6031 7.88376 54.5853 5.83301 58 5.83301C61.4147 5.83301 64.3978 7.8852 65.9033 10.9151C65.9669 11.0447 66 11.1879 66 11.3332C66 11.4784 65.9669 11.6216 65.9033 11.7512C64.397 14.7823 61.4147 16.833 58 16.833C54.5853 16.833 51.6022 14.7808 50.0967 11.751C50.0331 11.6213 50 11.4781 50 11.3329C50 11.1876 50.0331 11.0444 50.0967 10.9148ZM58 15.458C60.7403 15.458 63.2525 13.8825 64.6092 11.333C63.2525 8.78353 60.7406 7.20801 58 7.20801C55.2595 7.20801 52.7475 8.78353 51.3909 11.333C52.7472 13.8825 55.2595 15.458 58 15.458Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b",
    x: -4,
    y: -2,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 14.6667,
    fill: "white",
    transform: "matrix(-1 0 0 1 66 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriversinfoMarker);
export default __webpack_public_path__ + "static/media/driversinfo-marker.3836c158528d807e2deaa3176d208651.svg";
export { ForwardRef as ReactComponent };